export function dedent(text: string): string {
    return text.replace(/  +/g, '');
}
